import type { InstanceConfig } from "../../src/instance.js";

/**
 * Evolutivo — our OWN first-party dogfood deployment of evo-flywheel-kit-ai-portal
 * (ADR-001 §8), live at ai-portal.evolutivo.ai. Synced verbatim into
 * evo-flywheel-kit-ai-portal/web/instances/evolutivo/config.ts at build time and baked with
 * `vite build --mode evolutivo`. Shape must match evo-flywheel-kit-ai-portal/web/src/instance.ts
 * InstanceConfig.
 *
 * Portal tier (login + assistant chrome), the shell the deployment has run since 2026-10-04;
 * the agent spine (journeys/activities/deliverables/knowledge) converges our first-party work.
 */
const config: InstanceConfig = {
  name: "evolutivo",
  tier: "portal",
  brand: "Evolutivo AI Governance",
  logoSrc: "/logo.png",
  assistant: {
    title: "Assistente governance",
    emptyState:
      "Chiedi dei tuoi dati di governance AI — policy, rischi, revisioni — o usa le azioni rapide qui sopra.",
    placeholder: "Chiedi di policy, rischi o revisioni…",
    quickActions: [
      { key: "new-policy", icon: "FileProtectOutlined", label: "Nuova policy", prompt: "Crea una nuova policy: " },
      { key: "log-incident", icon: "SafetyOutlined", label: "Registra incidente", prompt: "Registra un incidente AI: " },
      { key: "prep-audit", icon: "AuditOutlined", label: "Prepara revisione", prompt: "Prepara una scheda di revisione per " },
      { key: "find", icon: "SearchOutlined", label: "Cerca…", prompt: "/find " },
    ],
  },
};

export default config;
